import React from 'react';
import {
  useFormContext,
} from 'react-hook-form';
import Controller from 'core/components/FormController';
import Button from 'pages/Dashboard/components/Button';
import {
  ReviewOfSystemElement,
} from 'pages/Dashboard/types/patient';
import {
  defaultDiscriminators,
} from 'pages/Dashboard/pages/Charts/pages/Details/utils/helper';
import ReviewInfo from 'pages/Dashboard/pages/Charts/pages/Details/components/ReviewOfSystems/ReviewInfoItem';
import clsx from 'clsx';
import {
  Props as TabProps,
} from 'pages/Dashboard/pages/Charts/pages/Details/types/tabContentProps';

type Parts = 'title' | 'body';

export type ReviewOfSystemsProps = Pick<TabProps, 'patient'> & {
  classes?: Partial<Record<Parts, string>>;
};

export default function ReviewOfSystems({ classes }: ReviewOfSystemsProps) {
  const {
    reset,
    getValues,
    control,
  } = useFormContext();

  const onPatientDeniesClick = () => {
    const groupedElements: Record<string, ReviewOfSystemElement[]> = {};

    defaultDiscriminators.forEach((discriminator) => {
      groupedElements[discriminator] = [{
        discriminator,
        title: 'Patient Denies',
        reviewOfSystemElementId: -1,
      }];
    });

    reset({
      ...getValues(),
      groupedReviewOfSystemElements: groupedElements,
    });
  };

  return (
    <div className="gap-4">
      <div className="flex items-baseline gap-4">
        <Controller
          name="groupedReviewOfSystemElements"
          control={control}
          render={({ field }) => (
            <Button
              color="primary"
              variant="text"
              onClick={onPatientDeniesClick}
              onBlur={field.onBlur}
            >
              Patient Denies All
            </Button>
          )}
        />
      </div>
      <div className={clsx('grid grid-cols-3 gap-3', classes?.body)}>
        {defaultDiscriminators.map((discriminator) => (
          <div
            key={discriminator}
            className="flex flex-col"
          >
            <ReviewInfo discriminator={discriminator} />
          </div>
        ))}
      </div>
    </div>
  );
}
